import FeedbacksScreen from "@/UI/screens/FeedbacksScreen";

export default function FeedbacksRoute() {
    return <FeedbacksScreen />;
}
